import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {CodebookService} from '|shared';
import {ApiRegistryOfficeTransferService, RegistryOfficeTransferTakeoverDto} from '|api/document';
import {TranslateService} from '@ngx-translate/core';
import {SearchRecordSourceRegistryOfficeTransferActivityDto} from '|api/elastic';
import {
  ButtonComponent,
  FormButtonsComponent,
  WaitingDirective,
  LoadingIndicatorService
} from '@icz/angular-essentials';
import {
  CheckboxComponent,
  FormAutocompleteComponent,
  IczFormContainerDirective,
  IczFormControl,
  IczFormGroup,
  IczOption,
  IczValidators
} from '@icz/angular-form-elements';
import {injectModalData, injectModalRef} from '@icz/angular-modal';
import {ReactiveFormsModule} from '@angular/forms';
import {
  CheckUnsavedFormDialogService,
  IczFormSubmitDirective,
  IFormGroupCheckable,
  namedDtosToOptions
} from '@icz/angular-application-core';
import {AsyncPipe} from '@angular/common';
import {RegistryOfficeToastService} from '|ui-essl-core';


@Component({
  selector: 'icz-transfer-activity-takeover-dialog',
  templateUrl: './transfer-activity-takeover-dialog.component.html',
  styleUrls: ['./transfer-activity-takeover-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    CheckUnsavedFormDialogService
  ],
  imports: [ReactiveFormsModule, IczFormContainerDirective, WaitingDirective, CheckboxComponent, FormAutocompleteComponent, FormButtonsComponent, ButtonComponent, IczFormSubmitDirective, AsyncPipe]
})
export class TransferActivityTakeoverDialogComponent implements OnInit, IFormGroupCheckable {

  protected loadingService = inject(LoadingIndicatorService);
  protected modalRef = injectModalRef<Nullable<boolean>>();
  private apiRegistryOfficeTransferService = inject(ApiRegistryOfficeTransferService);
  private codebookService = inject(CodebookService);
  protected checkUnsavedService = inject(CheckUnsavedFormDialogService);
  private registryOfficeToastService = inject(RegistryOfficeToastService);
  private translateService = inject(TranslateService);
  protected selection = injectModalData<SearchRecordSourceRegistryOfficeTransferActivityDto[]>();

  form = new IczFormGroup({
    registryOfficeId: new IczFormControl<Nullable<number>>(null, [IczValidators.required()]),
    showRegistryOfficeSelector: new IczFormControl<boolean>(false),
  });

  formGroupsToCheck!: string[];
  registryOfficeOptions: IczOption[] = [];

  ngOnInit(): void {
    this.checkUnsavedService.addUnsavedFormCheck(this, ['form']);

    this.loadingService.doLoading(
      this.codebookService.transferableRegistryOfficesForCurrentFunctionalPosition(),
      this
    ).pipe(namedDtosToOptions).subscribe(offices => {
      this.registryOfficeOptions = offices;
      this.form.get('registryOfficeId')!.setValue(this.selection[0].registryOfficeId!);
    });
  }

  submit() {
    const body: RegistryOfficeTransferTakeoverDto = {
      registryOfficeId: this.form.get('registryOfficeId')!.value!,
      transferActivityIds: this.selection.map(s => s.id!)
    };

    this.loadingService.doLoading(
      this.apiRegistryOfficeTransferService.registryOfficeTransferTransferTakeover({
        body
      }),
      this
    ).subscribe(_ => {
      this.modalRef.close(true);
    });
  }

  cancel() {
    this.modalRef.close(null);
  }

}
